import RecognitionHubViews from "@irati/recognition/constants/hubViewTypes"
import {Recognition} from "@irati/types"
import service from "@irati/utils/tracking/index"
import {get} from "lodash"
import {
  RecognitionConfirmationProps,
  CreateNewRecognitionProps,
  RecognitionCTAClickProps,
  RewardCreatedOnRecognitionProps,
  RewardOnRecognitionErrorProps
} from "./types"
class RecognitionTracking {
  defaultStatusCode = "200"

  startCreateRecognition = (source: "button" | "textbox" = "button") => {
    service.trackRecognitionEvent("start_create_recognition", {source})
  }

  createNewRecognition = ({type}: CreateNewRecognitionProps) => {
    service.trackRecognitionEvent("start_create_recognition", {
      source: "confirmation_modal",
      type
    })
  }

  launchRecognition = (poll: Recognition) => {
    const reward = get(poll, "reward.alt", null)
    const data = {
      statusCode: this.defaultStatusCode,
      reward
    }
    service.trackRecognitionEvent("launch_recognition", data)
  }

  errorsRecognition = (response) => {
    const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
    const data = {statusCode: `${statusCode}`}
    service.trackRecognitionEvent("recognition_error", data)
  }

  cancelRecognition = () => {
    service.trackRecognitionEvent("cancel_recognition")
  }

  recognitionCtaClick = (data: RecognitionCTAClickProps) => {
    service.trackRecognitionEvent("recognition_cta_click", data)
  }

  rewardCreatedOnRecognition = ({type}: RewardCreatedOnRecognitionProps) => {
    service.trackRecognitionEvent("reward_wallet_reward_employees_success", {
      source: "manager_reward",
      type
    })
  }

  rewardErrorOnRecognition = (data: RewardOnRecognitionErrorProps) => {
    service.trackRecognitionEvent("reward_wallet_reward_employees_error", data)
  }

  clickRewardBtn = (viewType?: RecognitionHubViews) => {
    if (!viewType) {
      return
    }
    service.trackCTAEvent({
      source: "add_reward_button",
      type: viewType === RecognitionHubViews.POPUP_VIEW ? "recognition_detail" : "feed_card"
    })
  }

  recognitionConfirmation = ({type}: RecognitionConfirmationProps) => {
    service.trackRecognitionEvent("recognition_confirmation", {
      source: "manager_confirmation",
      type
    })
  }
}

export default new RecognitionTracking()
